//import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

//import { IContextMenuItem } from '../../interfaces/icontext-menu-item.interface';
//import { ContextMenuItemBase } from '../menu/context-menu-item-base';
import { StructureComponent } from '../../../views/site/structure/structure.component';
import { Folder } from '../../models/site-content/folder.model';
//import { IListItem } from '../../interfaces/ilist-item.interface';
//import { FormInstance } from '../../models/site-content/form-instance.model';
//import { CopyFormInstanceDialog } from '../../dialogs/copy-form-instance/copy-form-instance.dialog';
//import { ClipboardService } from '../../services/clipboard.service';
//import { ItemTypeEnum } from '../../enums/item-type.enum';
//import { FolderService } from '../../services/folder.service';
//import { CurrentSiteService } from '../../services/current-site.service';
//import { MagicStructureSetupDialog } from '../../dialogs/magic-structure-setup/magic-structure-setup.dialog';
//import { ExportStructureInstancesDialog } from '../../dialogs/export-structure/export-structure.dialog';
//import { IHasIdAndName } from '../../interfaces/has-id-and-name.interface';
//import { FormInstanceService } from '../../services/form-instance.service';
//import { TrashDeleteEvent } from '../../components/list-view/list-view-trash-config.model';
import { StructureItemContextMenuItemBase } from './structure-context-menu-base';
//import { NewFolderClickHandler, NewFormClickHandler } from './page-button-config-click-handlers';
import { IButtonConfig, IButtonConfigClickHandler } from '../../components/list-view/list-view-button-config.model';
import { NewFolderDialog, NewFolderDialogManager } from '../../dialogs/new-folder/new-folder.dialog';
import { NewFormInstanceDialog, NewFormInstanceDialogManager } from '../../dialogs/new-form-instance/new-form-instance.dialog';
import { AlertDialogComponent, AlertDialogModel } from '../../dialogs/alert/alert-dialog.component';

// Define menu classes.
export class NewFolderContextMenuData extends StructureItemContextMenuItemBase implements IButtonConfigClickHandler {
    public constructor(itemTitle: string, structureComponent: StructureComponent) {
        super(itemTitle, structureComponent)
    }

    public menuItemSelected(contextItem: any, eventData: any): void {
        this.handleButtonClick(null, null, null);
    }

    public handleButtonClick(unusedButtonConfig: IButtonConfig, unusedEventData: any, contextItem: any): void {
        //const dialogRef = this.structureComponent.Dialog.open(NewFolderDialog);
        let newFolderDialogManager = new NewFolderDialogManager(this.structureComponent.ComponentHierarchyService);
        const dialogRef = newFolderDialogManager.openDialogUsing(this.structureComponent.Dialog);

        dialogRef.afterClosed().subscribe(result => {
            if (!result) return;
            let folderName = result.folderName;
            this.structureComponent.TreeIsStale = false;
            if (folderName && folderName.trim().length > 0) {
                folderName = folderName.trim();

                // If this folder does not already exist in the current folder, create it.
                let existingFolders: Folder[] = this.structureComponent.CurrentFolder.childFolders.filter(f => f.name.toLowerCase() == folderName.toLowerCase());
                if (existingFolders.length == 0) {
                    let folder = new Folder();

                    folder.name = folderName;
                    folder.parentFolderId = this.structureComponent.CurrentFolder.id;
                    folder.helpTextFormat = ""; // can't be null
                    folder.helpText = "";
                    folder.dataCollectionId = this.structureComponent.site.id;

                    this.structureComponent.FolderService.create(folder)
                        .then(createdFolder => {
                            this.structureComponent.updateDisplayOfEntity(createdFolder);
                            this.structureComponent.forceTreeRedraw();
                        });
                } else {
                    let message: string = `A folder named '${folderName}' already exists in the current folder.`;
                    let dialogueData: AlertDialogModel = new AlertDialogModel("Duplicate Name", message);
                    this.structureComponent.Dialog.open(AlertDialogComponent, {
                        maxWidth: "600px",
                        data: dialogueData
                    });
                }
            }
        });
    }
}

export class NewFormInstanceContextMenuData extends StructureItemContextMenuItemBase implements IButtonConfigClickHandler {
    public constructor(itemTitle: string, structureComponent: StructureComponent) {
        super(itemTitle, structureComponent)
    }

    public menuItemSelected(contextItem: any, eventData: any): void {
        this.handleButtonClick(null, null, null);
    }

    public handleButtonClick(unusedButtonConfig: IButtonConfig, unusedEventData: any, contextItem: any): void {
        let hshInitData = {
            width: '40%',
            hasBackdrop: this.structureComponent.ComponentHierarchyService.UITestCenterDialog == null,
            data: {
                currentFolder: this.structureComponent.CurrentFolder,
                formInstances: this.structureComponent.CurrentFolder.formInstances
            }
        };

        const dialogRef = this.structureComponent.Dialog.open(NewFormInstanceDialog, hshInitData);
        dialogRef.afterClosed().subscribe(newFormInstance => {
            if (newFormInstance) {
                if (newFormInstance instanceof Array) {
                    newFormInstance.forEach((fi) => {
                        this.structureComponent.FormInstanceService.create(fi);
                    });
                }
                else {
                    this.structureComponent.FormInstanceService.create(newFormInstance).then(savedFormInstance => {
                        this.structureComponent.updateDisplayOfEntity(savedFormInstance);
                    });
                }
            }
        });
    }
}

export class ShowTreeContextMenuData extends StructureItemContextMenuItemBase {
    public constructor(itemTitle: string, structureComponent: StructureComponent) {
        super(itemTitle, structureComponent)
    }

    public menuItemSelected(contextItem: any, eventData: any): void {
        this.structureComponent.doShowTree(eventData);
    }
}

export class HideTreeContextMenuData extends StructureItemContextMenuItemBase {
    public constructor(itemTitle: string, structureComponent: StructureComponent) {
        super(itemTitle, structureComponent)
    }

    public menuItemSelected(contextItem: any, eventData: any): void {
        this.structureComponent.doHideTree(eventData);
    }
}
